import { useSelector } from 'react-redux';
import TennisUser from '../tennisUser';
import './index.scss';
import { Link, useNavigate } from 'react-router-dom';
import { getAllShopOrdersAPI, updateOrderStatusAPI } from '../../apis/order';
import { getTennisOrderAPI } from '../../apis/auction';
import { useEffect, useState } from 'react';
import { Card, List, Pagination, Switch, Image } from 'antd';
import logo from '../../assets/logo.png';
import OrderTennisStatusManagerTag from '../OrderTennisStatusManagerTag';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';

const TennisOrderCheck = () => {
  const { userInfo } = useSelector((state: any) => state.user);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(4);
  const [visible, setVisible] = useState({});
  const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
  };
  const handleLogoClick = () => {
    navigate('/');
  };

  const paginatedOrders = orders
    .sort((a, b) => new Date(b.ctime).getTime() - new Date(a.ctime).getTime()) // 按照 ctime 倒序排列
    .slice((currentPage - 1) * pageSize, currentPage * pageSize);

  const handleToggleVisibility = (oid) => {
    setVisible((prevVisible) => ({
      ...prevVisible,
      [oid]: !prevVisible[oid],
    }));
  };

  const handleStatusChange = async (oid, newStatus) => {
    try {
      // 直接在本地 state 中根据 oid 更新对应订单的 status
      setOrders((prevOrders) =>
        prevOrders.map((order) =>
          order.oid === oid ? { ...order, status: newStatus } : order
        )
      );
    } catch (error) {
      console.error('Error updating order status:', error);
    }
  };
  useEffect(() => {
    const fetchOrders = async () => {
      try {
        if (!userInfo.userId) return;
        console.log('Fetching tennis orders for sellerId:', userInfo.userId);
        // 用 sellerId 查询该卖家的网球订单
        const resp = await getTennisOrderAPI({ sellerId: userInfo.userId });
        console.log('getTennisOrderAPI response:', resp);
        if (resp && resp.success && Array.isArray(resp.orders)) {
          const normalized = resp.orders.map((o: any) => ({
            ...o,
            oid: o.id ?? o.oid,
            amount: o.price ?? o.amount,
            ctime: o.created_at ?? o.ctime,
            orderFoodItems: o.orderFoodItems ?? [], // 若后端无明细则为空数组
            tableNumber: o.tableNumber ?? null,
          }));

          setOrders(normalized);
          // 初始化 visible 状态，使所有订单的 List 组件内容都显示
          const initialVisibleState = resp.orders.reduce((acc: any, order: any) => {
            acc[order.oid] = true;
            return acc;
          }, {});
          setVisible(initialVisibleState);
        } else {
          setOrders([]);
        }
      } catch (error) {
        console.error('Error fetching tennis orders by sellerId:', error);
      }
    };

    if (userInfo.userId) {
      fetchOrders();
    }
  }, [userInfo.userId]);

  return (
    <div className="purchaseHistoryContainer">
      <div className="scrollArea">
        <div className="header">
          <div className="backToTop">
            <img
              className="login-logo"
              src={logo}
              alt=""
              onClick={handleLogoClick}
            />
          </div>
          <span className="text">{t('tennisOrder.header')}</span>
          <div className="user-info">
            <TennisUser />
          </div>
        </div>
        <div className="order-container">
          {paginatedOrders.length === 0 ? (
            <Card title={t('tennisOrder.noHistory')} style={{ marginBottom: 16 }} />
          ) : (paginatedOrders.map((order) => (

            <Card
              key={order.oid}
              title={<div>
                {order.status === 'Pending' && (
                  <img className='newIcon' src="/uploads/default/new.jpg" alt="New" />
                )}
                <span style={{ marginLeft: '15px' }}>{t('tennisOrder.orderNumber')}: {order.oid}</span>
              </div>}
              style={{ marginBottom: 16 }}
              extra={
                <div className='extraContainer'>
                  <OrderTennisStatusManagerTag status={order.status} order={order} onStatusChange={(newStatus) => handleStatusChange(order.oid, newStatus)} />
                  <Switch
                    checked={visible[order.oid]}
                    onChange={() => handleToggleVisibility(order.oid)}
                    style={{ marginRight: 8 }}
                  />
                </div>
              }
            >
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <Image
                  width={50}
                  height={50}
                  src={order.reservation_screenshot_path ? order.reservation_screenshot_path : "/uploads/default/table.png"}
                  alt={`Table ${order.tableNumber}`}
                  style={{ marginRight: 16 }}
                  preview={false}
                />
                {order.tableNumber && (
                  <div className="cartCornerMark">{order.tableNumber}</div>
                )}
                <div>{t('tennisOrder.orderId')}: {order.id ?? order.oid}
                  <div>{t('tennisOrder.court')}: {order.court_name ?? '-'} {order.court_type ? `／ ${order.court_type}` : ''}</div>
                  <div>{t('tennisOrder.dateTime')}: {order.auction_date ? dayjs(order.auction_date).format('YYYY-MM-DD') : '-'}{order.time_range ? `　${order.time_range}` : ''}</div>
                </div>
              </div>
              {visible[order.oid] && (
                <div>
                  <p>{t('tennisOrder.paypayAccount')}: {order.paypay_account ?? '-'}</p>
                  <p>{t('tennisOrder.buyerEmail')}: {order.buyer_email ?? '-'}</p>
                  <p>{t('tennisOrder.paymentConfirmedAt')}: {order.payment_confirmed_at ?? '-'}</p>
                  <p>{t('tennisOrder.orderCreatedAt')}: {order.order_created_at ?? order.created_at ?? '-'}</p>
                  <p>{t('tennisOrder.auctionPrice')}: {Number(order.amount).toLocaleString()} 円</p>
                  <p>{t('tennisOrder.auctionStatus')}: {order.auction_status ?? '-'}</p>
                  <p>{t('tennisOrder.buyerName')}: {order.buyer_uname ?? '-'}</p>
                  <p>{t('tennisOrder.buyerPhone')}: {order.buyer_phoneNumber ?? '-'}</p>
                  <p>{t('tennisOrder.buyerMailAddress')}: {order.buyer_mailAddress ?? '-'}</p>
                  <p>{t('tennisOrder.buyerPaypayAccount')}: {order.buyer_paypay_account ?? '-'}</p>
                </div>
              )}
            </Card>
          )))}
        </div>
        <Pagination
          current={currentPage}
          pageSize={pageSize}
          total={orders.length}
          onChange={handlePageChange}
          style={{ textAlign: 'center', marginTop: 16 }}
        />
      </div>
    </div>
  );
};

export default TennisOrderCheck;
